export class DsoKartaTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        dirtyPrompt: "Ändringarna måste sparas innan du kan skapa nytt område"
    };
}
